import React, { useState, useEffect } from 'react';
import './queuedata.scss';
import '../topbar/topbar.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import PrintIcon from '@mui/icons-material/Print';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';

const Queuedata = () => {
  const [queues, setQueues] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchQueues = async () => {
      try {
        const storedToken = localStorage.getItem('accessToken');

        const response = await fetch(`${apiUrl}/queues`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch queues');
        }

        const data = await response.json();
        setQueues(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchQueues();
  }, [apiUrl]); // ✅ FIXED

  const handlePrintQueue = async (queueId) => {
    try {
      const response = await fetch(`${apiUrl}/printers/queue/${queueId}`, {
        method: 'POST',
      });

      console.log(response);

      if (!response.ok) {
        throw new Error('Failed to print queue');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <div className="navbar">
        <div className="wrapper">
          <div className="items">
            <div className="item">
              <Link to="/queues/addQueue" style={{ textDecoration: 'none' }}>
                <AddIcon className="icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <TableContainer component={Paper} className="reporttable">
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Queue Number</TableCell>
              <TableCell>Number of Customers</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {queues.map((queue) => (
              <TableRow key={queue._id}>
                <TableCell>{queue.queue_number}</TableCell>
                <TableCell>{queue.num_customers}</TableCell>
                <TableCell>{queue.status}</TableCell>
                <TableCell>{queue.created_at}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handlePrintQueue(queue._id)}>
                    <PrintIcon />
                  </IconButton>
                  <IconButton>
                    <ToggleOffIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Queuedata;